import { render } from "./CamposCustomForm.vue?vue&type=template&id=cf2645f0&scoped=true"
import script from "./CamposCustomForm.vue?vue&type=script&lang=js"
export * from "./CamposCustomForm.vue?vue&type=script&lang=js"

import "./CamposCustomForm.vue?vue&type=style&index=0&id=cf2645f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2645f0"]])

export default __exports__